import DailyDishes from "@/components/menu/DailyDishes";

const TabsDailyDish = () => {
  return <DailyDishes />;
};

export default TabsDailyDish;
